import { render, staticRenderFns } from "./ItemTiersList.vue?vue&type=template&id=73d0c690&"
import script from "./ItemTiersList.vue?vue&type=script&lang=js&"
export * from "./ItemTiersList.vue?vue&type=script&lang=js&"
import style0 from "./ItemTiersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports